<template>
	<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
		<path d="M3 21C3 21.5523 3.44772 22 4 22H13C13.5523 22 14 21.5523 14 21C14 20.4477 13.5523 20 13 20H5V12C5 11.4477 4.55228 11 4 11C3.44772 11 3 11.4477 3 12V21Z" :fill="fill_color" :fill-opacity="opacity"/>
		<path fill-rule="evenodd" clip-rule="evenodd" d="M1.58202 8.57061C1.27595 8.88919 1.27737 9.39301 1.58524 9.70985C1.90786 10.0419 2.44124 10.0411 2.76286 9.70807L6.17497 6.17508L2.72952 2.60859C2.4079 2.27567 1.8746 2.2749 1.55202 2.60689C1.24412 2.92378 1.24275 3.42767 1.54893 3.74622L3.88347 6.17508L1.58202 8.57061ZM9 3.00004H7.99997C7.44767 3.00004 6.99995 3.44778 6.99997 4.00007L7 5.00004V16L6.99997 17C6.99995 17.5523 7.44767 18 7.99997 18H9H20H21C21.5522 18 21.9999 17.5523 22 17.0001L22 16V5.00004V4.00004C22 3.44776 21.5523 3.00004 21 3.00004H20H9ZM9.00001 16.0001H20V5.00007H9.00001V16.0001Z" :fill="fill_color" :fill-opacity="opacity"/>
		<path d="M13.3333 14H15.6667V11.6667H18V9.33333H15.6667V7H13.3333V9.33333H11V11.6667H13.3333V14Z" :fill="fill_color" :fill-opacity="opacity"/>
	</svg>
</template>

<script>
import base_icon from '@/components/icons/base_icon';

export default {
	extends: base_icon
}
</script>
